import { render, staticRenderFns } from "./pricing.vue?vue&type=template&id=3c77b683"
import script from "./pricing.vue?vue&type=script&lang=js"
export * from "./pricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports